import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-black text-gray-300 py-12 border-t border-gray-800">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* About Section */}
                    <div>
                        <h3 className="text-2xl font-semibold text-white mb-4">About Kalabandhan</h3>
                        <p className="text-gray-400 mb-4">
                            Kalabandhan is dedicated to promoting and preserving Indian classical arts 
                            across America, creating a vibrant community of artists and enthusiasts.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-2xl font-semibold text-white mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="#home" className="hover:text-purple-400 transition duration-300">
                                    Home
                                </a>
                            </li>
                            <li>
                                <a href="#bharatanatyam" className="hover:text-purple-400 transition duration-300">
                                    Bharatanatyam
                                </a>
                            </li>
                            <li>
                                <a href="#carnatic-music" className="hover:text-purple-400 transition duration-300">
                                    Carnatic Music
                                </a>
                            </li>
                            <li>
                                <a href="#other-arts" className="hover:text-purple-400 transition duration-300">
                                    Other Art Forms
                                </a>
                            </li>
                            <li>
                                <a href="#gallery" className="hover:text-purple-400 transition duration-300">
                                    Gallery
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Information */}
                    <div>
                        <h3 className="text-2xl font-semibold text-white mb-4">Contact Us</h3>
                        <div className="space-y-2">
                            <p className="flex items-center">
                                <i className="fas fa-envelope mr-2"></i>
                                <a href="mailto:kalabandhan.ipa@gmail.com" className="hover:text-purple-400 transition duration-300">
                                    kalabandhan.ipa@gmail.com
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="text-center mt-8 pt-8 border-t border-gray-800">
                    <p className="text-gray-400">
                        © {new Date().getFullYear()} Kalabandhan. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
